import { Grid } from "@material-ui/core";
import { TextValidator } from 'react-material-ui-form-validator';

import { DocumentosForm } from './TipoComprobante/DocumentosForm'
import { PrestadoresForm } from './TipoComprobante/PrestadoresForm'
import { TRAMITE_COMPROBANTE_DOCUMENTO } from "../../../../utils/constants";

export const FormComprobante = ({formValues, handleInputChange, classes, setRestoCuenta,...props}) => {

  return (
    <Grid container spacing={1}>
      {props.menuPrestador ? (
        <PrestadoresForm
          formValues={formValues}
          handleInputChange={handleInputChange}
          setearValor={props.setearValor}
          setearValores={props.setearValores}
          setearVariosValores={props.setearVariosValores}
          presupuesto={props.presupuesto}
          cotizacion={props.cotizacion}
          letra={props.letra}
          setRestoCuenta={setRestoCuenta}
          proforma={props.proforma}
        /> 
       ) : (
        <DocumentosForm
          formValues={formValues}
          handleInputChange={handleInputChange}
          setearValor={props.setearValor}
          conEmbargo={Boolean(formValues?.idTramite === TRAMITE_COMPROBANTE_DOCUMENTO.EMBARGO)}
          toggleEmbargo={props.toggleEmbargo}
        />
      )}
      <Grid item xs={12}>
        <TextValidator
          multiline
          rows={5}
          fullWidth
          variant="outlined"
          margin="normal"
          label="Observaciones"
          name="observaciones"
          value={formValues.observaciones}
          onChange={handleInputChange}
          InputLabelProps={{ style: { fontWeight: 'bold' } }}
        />
      </Grid>
    </Grid>
  )
}
